/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraExtraUpdateDTO
 */
export interface ChiusuraExtraUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraExtraUpdateDTO
     */
    sequenza?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraExtraUpdateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraExtraUpdateDTO
     */
    importo?: number;
}

/**
 * Check if a given object implements the ChiusuraExtraUpdateDTO interface.
 */
export function instanceOfChiusuraExtraUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraExtraUpdateDTOFromJSON(json: any): ChiusuraExtraUpdateDTO {
    return ChiusuraExtraUpdateDTOFromJSONTyped(json, false);
}

export function ChiusuraExtraUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraExtraUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequenza': !exists(json, 'sequenza') ? undefined : json['sequenza'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
    };
}

export function ChiusuraExtraUpdateDTOToJSON(value?: ChiusuraExtraUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequenza': value.sequenza,
        'descrizione': value.descrizione,
        'importo': value.importo,
    };
}

